import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ConfigService } from 'src/app/_services/config.service';
import { SessionStorageService } from 'src/app/_services/session-storage.service';

@Component({
  templateUrl: 'reset-password.component.html',
  styleUrls: ['reset-password.component.css']
})

export class ResetPasswordComponent implements OnInit {
  isLoading = true;
  isDone = false;
  obfuscatedEmail = '';

  frmPassword = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(9)
  ]);
  frmConfirmPassword = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(9)
  ]);
  frmResetUsername = new UntypedFormControl('', [Validators.required]);
  passwordInputType = 'password';s

  constructor(
    private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private configService: ConfigService,
    private router: Router,
    private sessionStorageService: SessionStorageService,
    public snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    if (this.activatedRoute.snapshot.queryParams.jwt) {
      // TODO: Use a Guard to do this!
      this.sessionStorageService.set(
        'jsonToken',
        this.activatedRoute.snapshot.queryParams.jwt
      );
      this.router.navigateByUrl(`/auth/reset-password`);
    }
    this.isLoading = false;
  }

  onSubmitPasswordReset() {
    if (this.frmPassword.value !== this.frmConfirmPassword.value) {
      return this.snackBar.open('Passwords do not match', 'Dismiss', {
        duration: 8000
      });
    }

    this.isLoading = true;
    this.authenticationService
      .resetPassword(this.frmPassword.value)
      .toPromise()
      .then(
        data => {
          this.isDone = true;
          this.obfuscatedEmail = data.email;
          this.isLoading = false;
          this.snackBar.open(
            'You will be redirected to login in 5 seconds',
            'Dismiss',
            {
              duration: 5000
            }
          );
          setTimeout(() => {
            window.top.location.href = this.configService.get('mwiPortalUrl');
          }, 2000);
        },
        error => {
          this.isLoading = false;
          if (error.status === 401) {
            return this.snackBar.open('The password reset link has expired, please click "I forgot my password" to request a new password reset link.', 'Dismiss', {
              duration: 30000
            });
          }
          this.snackBar.open(error.errorMessage, 'Dismiss', {
            duration: 5000
          });
        }
      );
  }

  // UI toggles
  shouldDisableSubmitButton(): boolean {
    const bothValid = this.frmPassword.valid && this.frmConfirmPassword.valid;
    return !bothValid;
  }

  shouldShowLoader(): boolean {
    return this.isLoading;
  }

  onClickSubmitReset(): void {
    this.isLoading = true;
    this.authenticationService
      .requestPasswordReset(this.frmResetUsername.value)
      .toPromise()
      .then(
        ({ messageDetail }) => {
          this.isLoading = false;
          if (!messageDetail) {
            return;
          }

          return this.snackBar.open(
            messageDetail,
            'Dismiss',
            {
              duration: 30000
            }
          );
        },
        error => {
          this.isLoading = false;
          return this.snackBar.open(
            `Something went wrong while trying to send the reset email.`,
            'Dismiss',
            {
              duration: 8000
            }
          );
        }
      );
  }

  shouldDisableReset(): boolean {
    return !this.frmResetUsername.valid;
  }

  onClickPasswordIcon(): void {
    switch (this.passwordInputType) {
      case 'password':
        this.passwordInputType = 'text';
        break;
      case 'text':
        this.passwordInputType = 'password';
        break;
      default:
        this.passwordInputType = 'password';
        break;
    }
  }
}
